var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverlayKarte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Overlay-Karte__Icn/40px/Overlay-Karte",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Overlay-Karte__Color/20px/Platzhalter-Transparent",
    fillRule: "nonzero",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Overlay-Karte__Rectangle",
    d: "M0 0H40V40H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28,14 C29.1045695,14 30,14.8954305 30,16 L30,26 C30,27.1045695 29.1045695,28 28,28 L15,28 C13.8954305,28 13,27.1045695 13,26 L28,26 L28,14 Z M24,10 C25.1045695,10 26,10.8954305 26,12 L26,22 C26,23.1045695 25.1045695,24 24,24 L11,24 C9.8954305,24 9,23.1045695 9,22 L9,12 C9,10.8954305 9.8954305,10 11,10 L24,10 Z M13.6070517,17.4739864 C12.5642538,17.5875187 11.6982656,17.7792716 10.9993992,18.0458733 L11,22 L14.734,22 L13.6070517,17.4739864 Z M20.712,19.5502989 L16.233,20.5872989 L16.584,22 L21.348,22 L20.712,19.5502989 Z M23.999,18.789 L22.461,19.1452989 L23.202,22 L24,22 L23.999,18.789 Z M19.37765,14.4015594 C18.8144654,15.861243 17.5398252,16.8318409 15.4023429,17.2499966 L15.792,18.8152989 L20.254,17.7832989 L19.37765,14.4015594 Z M24,12 L20.607,12 L22.003,17.3792989 L24,16.916 L24,12 Z M12.245,12 L11,12 L10.9992082,16.12896 C11.6477014,15.9339864 12.3698705,15.7873897 13.1632853,15.6883241 L12.245,12 Z M17.936765,12.0015184 L14.096,12 L14.9627247,15.476199 C17.1658495,15.0709131 18.0348699,13.9827707 17.936765,12.0015184 Z",
    id: ".._.._src_svg_Icn_40px_Overlay-Karte__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlayKarte);
export default __webpack_public_path__ + "static/media/Overlay-Karte.399eb4667e744d76ab5c9221bcc94329.svg";
export { ForwardRef as ReactComponent };